const ROLE = {
  SNP_ADMIN: "SNP_ADMIN",
  SNP_MANAGER: "SNP_MANAGER",
  B2B_ADMIN: "B2B_ADMIN",
  B2B_MANAGER: "B2B_MANAGER",
} as const;

export default ROLE;
